import { observer } from 'mobx-react';
import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';

import { useProfileStore } from '@/stores/RootStore';

import routePaths from './routePaths';

function RedirectOnNonAdminUser({
  children,
}: PropsWithChildren) {
  const profileStore = useProfileStore();

  if (!profileStore.profile.isBusinessAdmin) {
    return <Navigate to={routePaths.root} replace />;
  }

  return <>{children}</>;
}

export default observer(RedirectOnNonAdminUser);
